import { UserUpdatePasswordTy } from "../../config/types";
import { apiService } from "../api.service";

export const activateUserAccount = async (form: Omit<UserUpdatePasswordTy,'confirmPassword'>) => {
  return apiService.apiRequest<any>("post", "auth/activate", form);
};
